import {Input as Logout} from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {AppBar, Link, Toolbar} from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import logo from '../../../assets/CoP_MasterLogo_RGB.svg';
import ChangeLanguage from '../../../components/ChangeLanguage';
import config from '../../../config/config';
import palette from '../../../theme/palette';
import {getLogoutUrl} from '../../../utils/auth';

const useStyles = makeStyles(() => ({
  logo: {
    width: 125,
    marginTop: 3
  },
  root: {
    backgroundColor: 'white'
  },
  changeLanguageLink: {
    position: 'absolute',
    top: '30%',
    right: '10%'
  },
  logoutIcon: {
    color: palette.button.secondary.color,
  },
  title: {
    flexGrow: 1
  }
}));

const Topbar = (props) => {

  const redirectLogout = () => {
    window.location.assign(getLogoutUrl(config));
  };

  const classes = useStyles();
  return (
    <AppBar
      className={classes.root}
      position="fixed">
      <Container maxWidth="lg">
        <Toolbar>
          <Typography color="inherit" noWrap className={classes.title}>
            <img src={logo} alt="CoP" className={classes.logo} />
          </Typography>
          {props.translate ? <div className={classes.changeLanguageLink}><ChangeLanguage /></div> : null}
          {!!props.withLogout && (
            <Link
              title="Sign out"
              href="#"
              onClick={redirectLogout}
              data-testid="logout-toolbar">
              <Logout color="primary" className={classes.logoutIcon} />
            </Link>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  translate: PropTypes.bool,
  withLogout: PropTypes.bool,
};

export default Topbar;
